import { render, staticRenderFns } from "./_SerialsPage.vue?vue&type=template&id=7434e964&scoped=true&"
import script from "./_SerialsPage.vue?vue&type=script&lang=ts&"
export * from "./_SerialsPage.vue?vue&type=script&lang=ts&"
import style0 from "./_SerialsPage.vue?vue&type=style&index=0&id=7434e964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7434e964",
  null
  
)

export default component.exports